<div class="scroll-top" id="scroll" [style.display]="scrollDisplay">
  <a class="cursor-pointer" (click)="scrollToTop()">
    <i class="fas fa-level-up-alt"></i>
  </a>
